import React, {  Fragment, useState } from 'react';

//Components
import { RenderCheckbox, RenderHeaderMessage } from './fragments';
import { RenderNameComponent, RenderDOBComponent } from '../search/fragments/renderCommonSearchComponents';

import Button from '../../../common/button/Button';
import Dropdown from '../../../common/form/Dropdown';
import Input from '../../../common/form/new/Input';
import GenericHeader from '../../../common/pageHeader/GenericHeader';
import { INPUT_TYPES } from '../../../common/form/constants/fieldTypes';
import ErrorMessage from '../../../common/form/errorMessage';

//Constants
import { COMMUNICATION_METHOD, ALL_DOCUMENT_TYPES, DOCUMENT_TYPES } from '../../constants/constants';


const IdProof = ({
    values,
    handleChange,
    handleSSNBlur,
    handleBlur,
    handleFocus,
    handleSubmit,
    stateCode,
    fieldErrors
}) => {

    const [options] = useState(() => {
        const modifiedOptions =  Object.entries(DOCUMENT_TYPES[stateCode]).map(([key, value]) => ({ value: value, text: value, id: key }));
        modifiedOptions.unshift({ value: '', id: 'Select', text: 'Select' });
        return modifiedOptions;
    });

    const [communicationOptions] = useState( () => {
        const modifiedOptions =  Object.entries(COMMUNICATION_METHOD).map(([key, value]) => ({ value: value, text: value, id: key }));
        modifiedOptions.unshift({ value: '', id: 'Select', text: 'Select' });
        return modifiedOptions;
    });

    const handleDocumentChange = (e) => {
        values.documentNumber = '';
        handleChange(e);
    };
    let documentTypePlaceHolder;
    if(values.documentType === ALL_DOCUMENT_TYPES.SSN) {
        documentTypePlaceHolder = 'XXX-XX-XXXX';
    } else if (values.documentType === ALL_DOCUMENT_TYPES.EMPLOYMENT_AUTHORIZATION_DOCUMENT) {
        documentTypePlaceHolder = 'XXX-XXX-XXX';
    } else documentTypePlaceHolder = '';

    return (
        <Fragment>
            <GenericHeader
                id='header'
                text='selfDesignation.attestation.header'
                tag="h1"
                headerClassName={['mobile:grid-col-12 tablet:grid-col-fill']}
            />

            <div className='gi-panel desktop:grid-col-fill tablet:grid-col-fill mobile-lg:grid-col-12 grid-col-12' id='ede-idProofing-panel'>
                <RenderCheckbox { ...{ handleChange, handleBlur, values }} />
                <RenderHeaderMessage />
                <div className="grid-row grid-gap-lg margin-t-10">
                    <RenderNameComponent { ...{ values, handleChange, handleBlur, handleFocus }} />
                    <RenderDOBComponent { ...{ values, handleChange, handleBlur, handleFocus }} />
                </div>
                <div className="grid-row grid-gap-lg margin-t-10">
                    <Dropdown
                        label={{
                            labelText:'selfDesignation.attestation.verifyConsumerIdentity.label.documentType',
                            labelClasses:['grid-col-12 txt-left'],
                            wrapperClasses:['grid-row gi-component grid-col-4']
                        }}
                        inputData={{
                            inputClasses:['gi-dropdown__select grid-col-12'],
                            name:'documentType',
                            options,
                            type:INPUT_TYPES.DROPDOWN,
                            selected: '',
                            value: values.documentType,
                            isInputRequired: true
                        }}
                        actions={{
                            handleFieldChange: handleDocumentChange,
                            handleFieldBlur: handleBlur
                        }}
                    />
                    <Input
                        label={{
                            labelText:'selfDesignation.attestation.verifyConsumerIdentity.label.documentNumber',
                            labelClasses: ['gi-input__label--col', 'grid-col-12'],
                            wrapperClasses: ['gi-input--col', 'grid-col-4'],
                            isRequired: true
                        }}
                        input={{
                            id: 'document-number',
                            name: 'documentNumber',
                            inputClasses: ['grid-col-12', 'margin-t-5'],
                            type: INPUT_TYPES.TEXT,
                            value: values.documentNumber,
                            placeholder: documentTypePlaceHolder,
                            minLength: 1,
                            maxLength: 60,
                            isInputRequired: true
                        }}
                        actions={{
                            handleFieldChange: value => handleChange({ target: { value, name: 'documentNumber' } }),
                            handleFieldBlur: value => handleSSNBlur( value),
                            handleFieldFocus: value => handleFocus({ target: { value, name: 'documentNumber' } })
                        }}
                    />
                    <Dropdown
                        label={{
                            labelText:'selfDesignation.attestation.verifyConsumerIdentity.label.Method',
                            labelClasses:['grid-col-12 txt-left'],
                            wrapperClasses:['grid-row gi-component grid-col-4']
                        }}
                        inputData={{
                            inputClasses:['gi-dropdown__select grid-col-12'],
                            name:'method',
                            options: communicationOptions,
                            type:INPUT_TYPES.DROPDOWN,
                            selected: '',
                            value: values.method,
                            isInputRequired: true
                        }}
                        actions={{
                            handleFieldChange: handleChange,
                            handleFieldBlur: handleBlur
                        }}
                    />
                </div>
                {
                    fieldErrors &&
                    <div className="grid-row error__msg--group margin-lr-0">
                        {fieldErrors.map(({ errorMsg }, index) => (
                            <ErrorMessage
                                key={index}
                                isVisible={true}
                                messageText={errorMsg}
                                errorWrapperClasses={['grid-col-12']}
                                errorClasses={[]}
                            />
                        ))}
                    </div>
                }
                <div className='grid-col-12 action__btn__wrapper'>
                    <Button
                        { ...{
                            id:'continue',
                            name:'continueBtn',
                            type: INPUT_TYPES.BUTTON,
                            outerClass: ['margin-b-20', 'display-inline'],
                            classes:['gi-button__primary'],
                            btnText:'selfDesignation.search.action-btn.continue',
                            handleClick: handleSubmit
                        }}

                    />
                </div>
            </div>
        </Fragment>
    );
};

export default IdProof;